import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';


export const useReferalApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);


  const getAllRefferal = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        // Only include search parameter if it has a value
        const searchParam =
          query.search && query.search.trim() !== '' ? query.search : undefined;
        // Correct argument order for generated client:
        // getReferralReport(page, limit, search?, sortBy?, sortOrder?, status?)
        const response = await api.getReferralReport(
          query.page,
          query.limit,
          searchParam,
          query.sortBy,
          query.sortOrder,
          undefined
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );


  return {
   getAllRefferal,
    loading,
    error,
   
  };
};
